import React from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';
import { rgba } from 'polished';
import theme from '../../../../theme';

const rotate = keyframes`
	100% {
		transform: rotate(360deg);
	}
`;

const dash = keyframes`
	0% {
		stroke-dasharray: 1, 150;
		stroke-dashoffset: 0;
	}
	50% {
		stroke-dasharray: 90, 150;
		stroke-dashoffset: -35;
	}
	100% {
		stroke-dasharray: 90, 150;
		stroke-dashoffset: -124;
	}
`;

const SpinnerSvg = styled.svg.attrs({
	viewBox: '0 0 50 50'
})`
	animation: ${rotate} 2s linear infinite;
	width: ${({ size }) => `${size}rem`};
	height: ${({ size }) => `${size}rem`};
	opacity: 0.75;

	circle {
		stroke: ${({ theme, color, opacity }) => rgba(theme[color], opacity)};
		stroke-linecap: round;
		animation: ${dash} 1.5s ease-in-out infinite;
	}
`;

function Spinner({ size = 3, color = 'white', opacity = 1 }) {
	return (
		<SpinnerSvg
			size={size}
			color={color}
			opacity={opacity}
		>
			<circle cx="25" cy="25" r="20" fill="none" strokeWidth="5" />
		</SpinnerSvg>
	);
}

Spinner.propTypes = {
	size: PropTypes.number,
	color: (props, propName, componentName) => {
		if( props[propName] ) {
			const value = props[propName];
			const isThemeColor = Object.keys(theme).includes(value);
			if( !isThemeColor ) {
				return new Error(
					`Invalid prop ${propName} supplied to ${componentName}. Must be a theme color.`
				);
			}
		}
		return null;
	},
	opacity: (props, propName, componentName) => {
		if( props[propName] ) {
			const value = props[propName];
			if( typeof value !== 'number' || value < 0 || value > 1 ) {
				return new Error(
					`Invalid prop ${propName} supplied to ${componentName}. Must be a number between 0 and 1.`
				);
			}
		}
		return null;
	}
};

export default React.memo(Spinner);
